import React from 'react';
import { plural } from 'utils/plural';

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model,
        mode  = model.currentName,
        selectOptions = [],
        pledge = "a-express-collateral",
        noPledge = "a-express-standard",
        isExpressEnergyOffer= window.location.href.includes('express_energy'),
        list = model.getListOfCredits(),
        current = model.getCurrentCredit(),
      phraseArray = ['CALCULATOR_FULL_MONTHS_02', 'CALCULATOR_FULL_MONTHS_01','CALCULATOR_FULL_MONTHS'],
      amountBtnsEnergy = (
        <div className="calculator-amount-wrapper">
          <button className={`amount-btn ${250000 === Number(model.getCreditSum()) ? "active" : ""}`} name="creditSum"
                  onClick={calc.handleChange} value={250000}>
            {(250000).toLocaleString() + " " + calc.l10n("UAH_ICON")}
          </button>
          <button className={`amount-btn ${500000 === Number(model.getCreditSum()) ? "active" : ""}`} name="creditSum"
                  onClick={calc.handleChange} value={500000}>
            {(500000).toLocaleString() + " " + calc.l10n("UAH_ICON")}
          </button>
          <button className={`amount-btn ${750000 === Number(model.getCreditSum()) ? "active" : ""}`} name="creditSum"
                  onClick={calc.handleChange} value={750000}>
            {(750000).toLocaleString() + " " + calc.l10n("UAH_ICON")}
          </button>
        </div>
      ),
      amountBtnsEnergyCollateral = (
        <div className="calculator-amount-wrapper">
          <button className={`amount-btn ${300000 === Number(model.getCreditSum()) ? "active" : ""}`} name="creditSum"
                  onClick={calc.handleChange} value={300000}>
            {(300000).toLocaleString() + " " + calc.l10n("UAH_ICON")}
          </button>
          <button className={`amount-btn ${500000 === Number(model.getCreditSum()) ? "active" : ""}`} name="creditSum"
                  onClick={calc.handleChange} value={500000}>
            {(500000).toLocaleString() + " " + calc.l10n("UAH_ICON")}
          </button>
          <button className={`amount-btn ${1000000 === Number(model.getCreditSum()) ? "active" : ""}`} name="creditSum"
                  onClick={calc.handleChange} value={1000000}>
            {(1000000).toLocaleString() + " " + calc.l10n("UAH_ICON")}
          </button>
        </div>
      ),
      termBtns = (
        <div className="calculator-terms-wrapper">
            <button className={`term-btn ${6 === Number(model.getCurrentTerm()) ? 'active' : ''}`} name="loanTerm" onClick={calc.handleChange1} value={6}>
                {"6"} {calc.l10n('CALCULATOR_FULL_MONTHS')}
            </button>
            <button className={`term-btn ${12 === Number(model.getCurrentTerm()) ? 'active' : ''}`} name="loanTerm"  onClick={calc.handleChange1} value={12}>
                {"1"} {calc.l10n('CALCULATOR_YEAR')}
            </button>
            <button className={`term-btn ${24 === Number(model.getCurrentTerm()) ? 'active' : ''}`} name="loanTerm" onClick={calc.handleChange1} value={24}>
                {"2"} {calc.l10n('CALCULATOR_YEARS')}
            </button>
          <button className={`term-btn ${36 === Number(model.getCurrentTerm()) ? 'active' : ''}`} name="loanTerm" onClick={calc.handleChange1} value={36}>
            {"3"} {calc.l10n('CALCULATOR_YEARS')}
          </button>
          <button className={`term-btn ${60 === Number(model.getCurrentTerm()) ? 'active' : ''} ${model.currentName === 'a-express-collateral' || model.currentName === 'express-energy-collateral' ? '' : 'hidden'}`} name="loanTerm" onClick={calc.handleChange1} value={60}>
            {"5"} {calc.l10n('CALCULATOR_YEARS_01')}
          </button>
        </div>
      );
    for (const i in list) {
        selectOptions.push(
        <button name={list[i]}
                key={list[i]}
                className={`${mode === list[i] ? "selected" : ""} btn-transparent`}
                onClick={calc.toggleMode}>
            {calc.l10n(list[i].toUpperCase())}
        </button>,
        );
    }

    return (
        <React.Fragment>
            <div className="calculator-controllers aexpress-controllers">
                <h2 className="calc-title" dangerouslySetInnerHTML={{__html: calc.l10n('CREDIT_CALCULATOR_NAME')}}></h2>
                <div className="aexpress-wrapper">
                    <div className="mode-switchers">
                        {selectOptions}
                    </div>
                    <div className="notification">
                        {current === "a-express-collateral" || current === "express-energy-collateral" ?  calc.l10n('A-EXPRESS-WITH-MAX') : calc.l10n('A-EXPRESS-MAX')} - &nbsp;
                        {model.getMaxSumEdge() / 1000 < 1000
                            ? `${model.getMaxSumEdge() / 1000} ${calc.l10n('CALCULATOR_THOUSAND')}`
                            : model.getMaxSumEdge() / 1000000 < 1000
                            ? `${model.getMaxSumEdge() / 1000000} ${calc.l10n(
                                  'CALCULATOR_MILLION',
                              )}`
                            : ''}
                        &nbsp;{calc.l10n('CALCULATOR_UAH')}
                    </div>
                </div>

                <div className="controller-block">
                    <div className="calc-block-title" >{calc.l10n('CALCULATOR_CREDIT_SUM')}<span className='calc-block-title-gray'> ( {calc.l10n('CALCULATOR_CREDIT_SUM_FROM')} {model.getMinSumEdge().toLocaleString('uk-UA')} {calc.l10n('CALCULATOR_CREDIT_SUM_TO')} {model.getMaxSumEdge().toLocaleString('uk-UA')} {calc.l10n('UAH_ICON')} )</span></div>

                    <div className="calculator-slider-wrapper">
                        <div className="calculator-input-wrapper">
                            <input name="creditSum" type="text"
                                   className="calculator-slider-value"
                                   min={model.getMinSumEdge()}
                                   max={model.getMaxSumEdge()}
                                   value={model.getCreditSum().toLocaleString('uk-UA')}
                                   onChange={calc.handleChangeInput}
                                   onBlur={calc.blurChangeInput}>
                            </input>
                            <span ref={calc.hiddenValue} className='hidden-value'>{model.getCreditSum().toLocaleString('uk-UA')}</span>
                            <span style={{left: `${calc.state.valueWith + 4}px`}}>{calc.l10n('UAH_ICON')}</span>
                        </div>
                        <div className="calculator-slider">
                            <input type="range"
                                   name="creditSum"
                                   className="calculator-sum-slide"
                                   onChange={calc.handleChange}
                                   value={model.getCreditSum()}
                                   min={model.getMinSumEdge()}
                                   max={model.getMaxSumEdge()}
                                   step={model.getSumStep()}
                                   style={{background: `linear-gradient(90deg, #4BDF7F ${calc.state.rangePercent}%, rgba(13, 12, 34, 0.1) ${calc.state.rangePercent}%)`}}
                            />
                        </div>
                    </div>
                </div>
              {current === "express-energy-collateral" || current === 'a-express-collateral' ? amountBtnsEnergyCollateral : amountBtnsEnergy}
              <div className="controller-block  ">
                <div className="calc-block-title">
                  {calc.l10n('CALCULATOR_CREDIT_FORM')}
                  <span className='calc-block-title-gray'> ({calc.l10n('CALCULATOR_CREDIT_SUM_TO')} {model.getMaxTermEdge()} {calc.l10n('CALCULATOR_FULL_MONTHS')})</span>
                </div>
                <div className="calculator-slider-wrapper">
                  <div className="calculator-slider-value">
                    {model.getCurrentTerm()} {calc.l10n(`${plural(model.getCurrentTerm(), phraseArray )}`)}
                  </div>

                  <div className="calculator-slider">
                    <input type="range"
                           name="loanTerm"
                           className="calculator-sum-slide"
                           onChange={calc.handleChange1}
                           value={model.getCurrentTerm()}
                           min={model.getMinTermEdge()}
                           max={model.getMaxTermEdge()}
                           step="1"
                           style={{background: `linear-gradient(90deg, #00D352 ${calc.state.rangePercent1}%, rgba(13, 12, 34, 0.1) ${calc.state.rangePercent1}%)`}}

                    />
                  </div>
                </div>
              </div>
                {termBtns}
            </div>
        </React.Fragment>
    );
}
